import React from "react";

import ProjectList from "./ProjectList";
import ListWrapper from "../ListWrapper";
import ListContentWrapper from "../ListContentWrapper";
import AdminSearchWidget from "../../../features/management/db-list/AdminSearchWidget";

import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";

import {
  genDisplayCount,
  getTimestampTomorrow,
  getTimeStampYesterday,
} from "../../../utils/GeneralUtils";
import { useGetProjectAdmin } from "../../../utils/useProject";

type Props = {
  handleSearch?: (search: Array<string>) => void;
  handleStatus?: (status: string) => void;
  handlePeriod?: (period: string) => void;
  currentPage: number;
  perView: number;
  isSelect: boolean;
  search?: Array<string>;
  status?: string | string[];
  period?: string;
};

const ProjectListContainer: React.FC<Props> = ({
  handleSearch,
  handleStatus,
  handlePeriod,
  currentPage,
  perView,
  isSelect,
  search,
  status,
  period,
}) => {
  const auth_token = useAppSelector(getAuthToken);

  const {
    items: { projects, owners, total_entries: entries, total_pages: totalPage },
    isLoading,
  } = useGetProjectAdmin(
    {
      auth_token: auth_token,
      is_jikei_request: !isSelect,
      page: currentPage,
      per: perView,
      search: search?.join(" "),
      status: status,
      currently_publishing: period === "now" ? "true" : undefined,
      date_end_before: period === "end" ? getTimeStampYesterday() : undefined,
      date_start_after:
        period === "future" ? getTimestampTomorrow() : undefined,
    },
    auth_token ? true : false
  );

  return (
    <ListWrapper pageTitle={"プロジェクト一覧"}>
      <ListContentWrapper
        displayCount={genDisplayCount(currentPage, totalPage, perView, entries)}
        totalEntries={entries}
        currentPage={currentPage}
        totalPage={totalPage}
        isLoading={isLoading}
        handleStatus={handleStatus}
        status={status}
        handlePeriod={handlePeriod}
        period={period}
        optionalComponent={
          handleSearch && search ? (
            <AdminSearchWidget handleSearch={handleSearch} search={search} />
          ) : undefined
        }
      >
        <ProjectList projects={projects} isSelect={isSelect} owners={owners} />
      </ListContentWrapper>
    </ListWrapper>
  );
};

export default ProjectListContainer;
